import { render, staticRenderFns } from "./closing-contact.vue?vue&type=template&id=a0c86710"
import script from "./closing-contact.vue?vue&type=script&lang=js"
export * from "./closing-contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports